import { Box, Grid, Popover, Typography } from '@mui/material';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { isEqual, isNull } from 'underscore';
import { useSelector } from 'react-redux';

import { localDateTime } from '../../Common/timeUtils';
import { PlanningTable } from '../../UserManagement/PlanningTable';
import { RootState } from '../../../index';
import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DepartureBoardOutlined } from '@mui/icons-material';

const useStyles = makeStyles(() => ({
  box: {
    display: 'flex',
    minHeight: '48px',
    borderRadius: '3px',
    padding: '10px',
    backgroundColor: alpha('#fff', 0.4),
    cursor: 'pointer'
  },
  noPlan: {
    minWidth: '110px',
  },
  withPlan: {
    minWidth: '170px',
  },
  innerContent: {
    marginLeft: '10px',
    fontSize: '14px'
  },
  noPlanText: {
    color: 'white',
    fontSize: '1.2rem',
    fontWeight: 'bold'
  },
  innerbox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '0',
    marginLeft: '0',
  },
  generalIcon: {
    color: '#FFFFFF8A',
  },
  /* responsive */
  '@media (max-width: 1300px)': {
    withPlan: {
      minWidth: '151px',
      padding: '6px 8px',
      minHeight: '48px'
    },
    innerContent: {
      fontSize: '13px',
    },
    noPlanText: {
      fontSize: '1rem',
    },
  },
}));

export const PlanningActions = () => {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [menu, setMenu] = useState<{ open: boolean; anchor: HTMLElement | null; }>({ open: false, anchor: null });
  const { selected_process, ui, recent_planning_date } = useSelector(
    (state: RootState) => state.core,
    isEqual
  );

  useEffect(() => {
    if (ui.length) setReady(true);
  }, [ui]);

  if (!ready) return null;
  if (!ui.includes('planning_table')) return null;

  const handleMenu = (event: SyntheticEvent) => {
    const newAnchor = isNull(menu.anchor) ? (event.currentTarget as HTMLElement) : null;
    setMenu({ open: !menu.open, anchor: newAnchor });
  };

  const handleCloseModal = () => setMenu({ open: false, anchor: null });

  const noPlan = !selected_process && !recent_planning_date;

  return (
    <Box px={0} className={`${classes.box} ${noPlan ? classes.noPlan : classes.withPlan}`} style={{ flexShrink: 0 }}>
      <Grid
        container
        className={classes.innerbox}
        spacing={2}
        onClick={(e: SyntheticEvent) => handleMenu(e)}
        id="planning-actions-menu"
      >
        <Grid container alignItems={'center'} justifyContent={'center'}>
          <DepartureBoardOutlined className={classes.generalIcon} />
          <Typography className={classes.innerContent}>
            {noPlan ? (
              <span className={classes.noPlanText}>--</span>
            ) : (
              localDateTime(new Date(selected_process?.timestamp || recent_planning_date))
            )}
          </Typography>
        </Grid>
      </Grid>

      {!noPlan && (
        <Popover
          open={menu.open}
          onClose={() => setMenu({ open: false, anchor: null })}
          anchorEl={menu.anchor}
          PaperProps={{ style: { width: 600, height: 500 } }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <div data-cy="header-table-container">
            <PlanningTable closeModal={handleCloseModal} />
          </div>
        </Popover>
      )}
    </Box>
  );
};
